// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-dialog-public-shared-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dl-dialog-public-shared-link__input-place {
  min-width: 280px;
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}
.dl-dialog-public-shared-link__input-link_active > input {
  color: var(--g-color-text-complementary);
}
.dl-dialog-public-shared-link__clipboard-button {
  display: flex;
  align-items: center;
  margin-left: 16px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/EntryDialogues/DialogSwitchPublic/DialogPublic/SharedLink/SharedLink.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AACJ;AACI;EACI,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AACR;AAEI;EACI,wCAAA;AAAR;AAGI;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;AADR","sourcesContent":[".dl-dialog-public-shared-link {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.dl-dialog-public-shared-link__input-place {\n  min-width: 280px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n.dl-dialog-public-shared-link__input-link_active > input {\n  color: var(--g-color-text-complementary);\n}\n.dl-dialog-public-shared-link__clipboard-button {\n  display: flex;\n  align-items: center;\n  margin-left: 16px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
